<script setup>
import { useDarkMode } from './composables/useDarkMode';
import { useAuth } from './composables/useAuth';
import { useRouter } from 'vue-router';

useDarkMode(); // Initialize dark mode settings
const { currentUser, signOut: firebaseSignOut, loading: authLoading } = useAuth();
const router = useRouter();

const handleSignOut = async () => {
  await firebaseSignOut();
  router.push('/'); // Redirect to home or login page after sign out
};
</script>

<template>
  <div class="min-h-screen bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-gray-100">
    <header class="bg-blue-600 text-white p-4 shadow-md">
      <div class="container mx-auto flex justify-between items-center">
        <h1 class="text-2xl font-bold">
          <router-link to="/" class="hover:text-blue-200">Exam Engine</router-link>
        </h1>
        <nav v-if="!authLoading">
          <ul class="flex space-x-4 items-center">
            <li v-if="currentUser">
              <span class="text-sm hidden sm:inline">Welcome, {{ currentUser.displayName || currentUser.email }}</span>
            </li>
            <li v-if="currentUser">
              <router-link to="/performance" class="hover:text-blue-200 text-sm">Track My Performance</router-link>
            </li>
            <li v-if="currentUser">
              <button @click="handleSignOut" class="hover:text-blue-200 text-sm">Logout</button>
            </li>
            <li v-if="!currentUser">
              <router-link to="/signup" class="hover:text-blue-200 text-sm">Login / Sign Up</router-link>
            </li>
          </ul>
        </nav>
        <div v-else>
          <!-- Optional: Auth loading indicator -->
          <span class="text-sm">Loading user...</span>
        </div>
      </div>
    </header>
    
    <main class="container mx-auto p-4">
      <router-view />
    </main>
    
    <footer class="bg-gray-200 dark:bg-gray-800 p-4 text-center text-gray-600 dark:text-gray-300 mt-8">
      <p>© 2025 Exam Engine</p>
    </footer>
  </div>
</template>
